import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllSupplierApi,
  GetDashboardDataApi,
  GetExpenseApi,
} from "../../ApiRequests";

export const fetchDashboardData = createAsyncThunk(
  "fetch/Dashboard",
  async () => {
    try {
      const response = await GetDashboardDataApi();
      console.log(response?.data?.data);
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);
// export const  = createAsyncThunk("fetch-items", async () => {});

const DashboardSlice = createSlice({
  name: "Dashboard",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardData.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchDashboardData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchDashboardData.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default DashboardSlice.reducer;
